import { Theme } from '@monorepo/relayably/theme'
import React from 'react'
import { ScrollView, StyleSheet, Text, View } from 'react-native'
import { DashboardCallDetail } from '../types'

const hexToRgba = (hex: string, alpha: number) => {
  const value = hex.replace('#', '')
  const expanded =
    value.length === 3
      ? value
          .split('')
          .map(char => `${char}${char}`)
          .join('')
      : value
  const r = parseInt(expanded.slice(0, 2), 16)
  const g = parseInt(expanded.slice(2, 4), 16)
  const b = parseInt(expanded.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const CallDetailScreen = ({ theme, call }: { theme: Theme; call: DashboardCallDetail }) => {
  const styles = createStyles(theme)

  return (
    <ScrollView contentContainerStyle={styles.content} showsVerticalScrollIndicator={false}>
      <View style={styles.summaryCard}>
        <Text style={styles.phone}>{call.phoneNumber}</Text>
        <Text style={styles.meta}>
          {call.agentName} • {new Date(call.startedAt).toLocaleString()}
        </Text>
        <Text style={styles.insight}>{call.insights}</Text>
      </View>

      <View style={styles.transcriptList}>
        {call.transcript.map(turn => (
          <View key={turn.id} style={[styles.bubble, turn.role === 'assistant' ? styles.assistantBubble : styles.userBubble]}>
            <Text style={[styles.role, turn.role === 'assistant' ? styles.assistantRole : styles.userRole]}>
              {turn.role === 'assistant' ? 'Relayably' : turn.role === 'user' ? 'Caller' : 'System'}
            </Text>
            <Text style={[styles.bubbleText, turn.role === 'assistant' ? styles.assistantText : styles.userText]}>{turn.text}</Text>
          </View>
        ))}
      </View>
    </ScrollView>
  )
}

const createStyles = (theme: Theme) =>
  StyleSheet.create({
    content: {
      gap: 16,
      paddingBottom: 24,
    },
    summaryCard: {
      borderRadius: 22,
      padding: 20,
      backgroundColor: hexToRgba(theme.colors.surface, 0.96),
      borderWidth: 1,
      borderColor: hexToRgba(theme.colors.primary, 0.1),
      gap: 8,
    },
    phone: {
      color: theme.colors.text,
      fontFamily: 'Georgia',
      fontSize: 28,
      lineHeight: 32,
    },
    meta: {
      color: theme.colors.inactive,
      fontSize: 13,
      lineHeight: 20,
    },
    insight: {
      color: theme.colors.text,
      fontSize: 15,
      lineHeight: 24,
      marginTop: 6,
    },
    transcriptList: {
      gap: 12,
    },
    bubble: {
      maxWidth: '88%',
      borderRadius: 20,
      padding: 16,
      gap: 8,
    },
    assistantBubble: {
      alignSelf: 'flex-start',
      backgroundColor: hexToRgba(theme.colors.surface, 0.94),
      borderWidth: 1,
      borderColor: hexToRgba(theme.colors.primary, 0.08),
    },
    userBubble: {
      alignSelf: 'flex-end',
      backgroundColor: hexToRgba(theme.colors.primary, 0.15),
    },
    role: {
      fontSize: 11,
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: 0.8,
    },
    assistantRole: {
      color: theme.colors.primary,
    },
    userRole: {
      color: theme.colors.text,
    },
    bubbleText: {
      fontSize: 14,
      lineHeight: 22,
    },
    assistantText: {
      color: theme.colors.text,
    },
    userText: {
      color: theme.colors.text,
    },
  })
